<template>
  <left-box-element
    @update:size="setOptimalChartSize"
  >
    <template #element-title>
      <h1>{{ $t("helpdesk.landingPage.progressSectionTitle") }}</h1>
    </template>

    <template #element-content>
      <el-container
        v-if="!lineChartSeries[0].data.length"
        v-loading="isLoading"
        class="landing-page-element-body loading-box"
      />

      <transition name="el-fade-in-linear">
        <el-container
          v-if="lineChartSeries[0].data.length"
          v-loading="isLoading"
          class="landing-page-element-body"
        >
          <el-main class="line-chart-box">
            <line-chart
              :chart-series="lineChartSeries"
              :chart-width="lineChartWidth"
              :initial-date-range="dateRange"
            />
          </el-main>
        </el-container>
      </transition>
    </template>
  </left-box-element>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import moment from 'moment'

import LeftBoxElement from '@/components/Helpdesk/LandingPage/LeftBoxElement.vue'

import LineChart from '@/components/UI/LineChart.vue'

import {
  TicketsStatisticsQuery
} from '@/types/graphql'

interface ProgressOfRequestsChartDay {
  x: string
  y: number
  fillColor: string
}

interface ProgressOfRequestsChartSeries {
  name: string
  data: Array<ProgressOfRequestsChartDay>
}

@Component({
  components: {
    LeftBoxElement,
    LineChart
  }
})

export default class extends Vue {
  private isLoading = false

  private lineChartWidth = 0

  private lineChartSeries: Array<ProgressOfRequestsChartSeries> = [{
    name: '',
    data: []
  }]

  private progressOfRequestsChartSeries(series: NonNullable<TicketsStatisticsQuery['ticketsStatistics']['progression_days'][0]>[]) {
    const oneDay: ProgressOfRequestsChartDay = {
      x: '',
      y: 0,
      fillColor: ''
    }
    const finalSeries: Array<ProgressOfRequestsChartDay> = []
    series.forEach(element => {
      Vue.set(oneDay, 'x', element.date_tickets)
      Vue.set(oneDay, 'y', element.no_tickets)
      finalSeries.push({ x: element.date_tickets, y: element.no_tickets, fillColor: 'hsl(25, 100%, 50%)' })
    })

    for (let i = 1; i < finalSeries.length; i++) {
      if (finalSeries[i].y < finalSeries[i - 1].y) {
        finalSeries[i].fillColor = 'hsl(170, 100%, 40%)'
      }
    }

    this.lineChartSeries[0].data = finalSeries
  }

  private setOptimalChartSize(val: any) {
    this.lineChartWidth = Math.round(val.elementWidth) - 20
  }

  private async getTicketStatisticsQuery() {
    this.isLoading = true
    this.$apollo
      .query({
        query: TicketsStatisticsQuery,
        fetchPolicy: 'network-only'
      })
      .then(res => {
        this.progressOfRequestsChartSeries(res.data.ticketsStatistics.progression_days)
      })
      .finally(() => {
        this.isLoading = false
      })
  }

  created() {
    this.getTicketStatisticsQuery()
  }

  @Watch('$i18n.locale')
  private languageChanged() {
    this.getTicketStatisticsQuery()
  }

  private dateRange = moment().valueOf() - moment().subtract(30, 'days').valueOf()
}
</script>
